<script setup lang="ts">
import { RouterLink } from 'vue-router'

import logoUrl from './revup-logo.svg'
</script>

<template>
  <RouterLink to="/" class="flex shrink-0 items-center" data-testid="brand-mark-link">
    <img :src="logoUrl" alt="" aria-hidden="true" width="80" class="block h-auto" />
    <p class="sr-only">revUP</p>
  </RouterLink>
</template>
